import type { Client, UserAccessScope } from '../types'

interface Props {
  administratorLocked?: boolean
  clients: Client[]
  scope: UserAccessScope
  onChange: (scope: UserAccessScope) => void
}

export function UserAccessSettings({ administratorLocked = false, clients, scope, onChange }: Props) {
  const isAdministrator = administratorLocked

  function toggleAllClients(checked: boolean) {
    if (checked) {
      onChange({ allClients: true, clients: {} })
      return
    }
    onChange({
      allClients: false,
      clients: Object.fromEntries(clients.map(client => [client.id, { allOperations: true, operations: [] }])),
    })
  }

  function toggleClient(client: Client, checked: boolean) {
    const nextClients = { ...scope.clients }
    if (checked) nextClients[client.id] = { allOperations: true, operations: [] }
    else delete nextClients[client.id]
    onChange({ ...scope, clients: nextClients })
  }

  function toggleAllOperations(client: Client, checked: boolean) {
    onChange({
      ...scope,
      clients: {
        ...scope.clients,
        [client.id]: { allOperations: checked, operations: checked ? [] : [...client.operations] },
      },
    })
  }

  function toggleOperation(clientId: string, operation: string, checked: boolean) {
    const clientScope = scope.clients[clientId]
    if (!clientScope) return
    const operations = checked
      ? [...new Set([...clientScope.operations, operation])]
      : clientScope.operations.filter(item => item !== operation)
    onChange({ ...scope, clients: { ...scope.clients, [clientId]: { allOperations: false, operations } } })
  }

  return <div className="account-access-settings">
    <div className="account-access-title"><span>CLIENTES E OPERAÇÕES VISÍVEIS</span><small>{isAdministrator ? 'Acesso integral obrigatório para a conta administradora.' : 'Esse escopo controla campanhas, tarefas e relatórios.'}</small></div>
    <label className={`access-all-toggle ${isAdministrator ? 'locked' : ''}`}><input type="checkbox" checked={isAdministrator || scope.allClients} disabled={isAdministrator} onChange={event => toggleAllClients(event.target.checked)}/><span><b>Todos os clientes e operações</b><small>Inclui automaticamente novos clientes cadastrados.</small></span></label>
    {!isAdministrator && !scope.allClients && <div className="client-access-options">
      {clients.map(client => {
        const clientScope = scope.clients[client.id]
        return <div className={`client-access-option ${clientScope ? 'selected' : ''}`} key={client.id}>
          <label className="client-access-check"><input type="checkbox" checked={Boolean(clientScope)} onChange={event => toggleClient(client, event.target.checked)}/><span><b>{client.name}</b><small>{clientScope ? client.operations.length ? `${client.operations.length} operações disponíveis` : 'Cliente sem operações cadastradas' : 'Sem acesso'}</small></span></label>
          {clientScope && client.operations.length > 0 && <div className="operation-access-options">
            <label><input type="checkbox" checked={clientScope.allOperations} onChange={event => toggleAllOperations(client, event.target.checked)}/><span>Todas as operações</span></label>
            {!clientScope.allOperations && client.operations.map(operation => <label key={operation}><input type="checkbox" checked={clientScope.operations.includes(operation)} onChange={event => toggleOperation(client.id, operation, event.target.checked)}/><span>{operation}</span></label>)}
          </div>}
        </div>
      })}
      {!clients.length && <p className="access-empty">Cadastre um cliente para configurar a participação.</p>}
    </div>}
  </div>
}
